import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

const GrnRejectionViewSingleReport = () => {
  useAuthRedirect();
    const {poNo, grnNo, oldGrn} = useParams();
    const branch = localStorage.getItem("branch");
    const [poDetail, setPoDetail] = useState({});
    const [data, setData] = useState([]);

    const [subDetails, setSubDetails] = useState({})

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_detailsHeader?poNo=${poNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                purchaseOrderHeader_suppliercode: items[0].purchaseOrderHeader_suppliercode,
                purchaseOrderHeader_podate: items[0].purchaseOrderHeader_podate,
                purchaseOrderHeader_supplierName: items[0].purchaseOrderHeader_supplierName,
                purchaseOrderHeader_yourReferenceNumber: items[0].purchaseOrderHeader_yourReferenceNumber,
                purchaseOrderHeader_yourReferenceDate: items[0].purchaseOrderHeader_yourReferenceDate,
                purchaseOrderHeader_ourReferenceNumber: items[0].purchaseOrderHeader_ourReferenceNumber,
                purchaseOrderHeader_ourReferenceDate: items[0].purchaseOrderHeader_ourReferenceDate,
                purchaseOrderHeader_value: items[0].purchaseOrderHeader_value,
                purchaseOrderHeader_discount: items[0].purchaseOrderHeader_discount,
                purchaseOrderHeader_pfcharges: items[0].purchaseOrderHeader_pfcharges,
                purchaseOrderHeader_freightCharges: items[0].purchaseOrderHeader_freightCharges,
                purchaseOrderHeader_totalValue: items[0].purchaseOrderHeader_totalValue,
                PurchaseOrderHeader_Transport: items[0].PurchaseOrderHeader_Transport,
                purchaseOrderHeader_paymentTerms: items[0].purchaseOrderHeader_paymentTerms,
                purchaseOrderHeader_deliveryMethod: items[0].purchaseOrderHeader_deliveryMethod,
                purchaseOrderHeader_deliveryPlace: items[0].purchaseOrderHeader_deliveryPlace,
                PurchaseOrderHeader_PriceBasis: items[0].PurchaseOrderHeader_PriceBasis,
                purchaseOrderHeader_remarks: items[0].purchaseOrderHeader_remarks,
                purchaseOrderHeader_cstTax: items[0].purchaseOrderHeader_cstTax,
                
            };

            setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [poNo]); 

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${poDetail.purchaseOrderHeader_suppliercode}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeaderCity = {
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1,
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2,
                supplierMaster_city : items[0].supplierMaster_city,
                supplierMaster_pincode : items[0].supplierMaster_pincode,
                
            };
            setSubDetails(storeReqHeaderCity);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.purchaseOrderHeader_suppliercode]); 



  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/grnReject_detailsBottom?branch=${branch}&poNo=${poNo}&grnNo=${grnNo}`)
      .then((response) => {
        if (response.data && response.data.headerDetails2) {
          setData(response.data.headerDetails2);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]); 
      });
  }, [branch, poNo, grnNo]);
  

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
                                                  <h2 className="add-txt">GRN Rejection View</h2>
                                                  <Link to='/inventory/grnRejectionReport'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                                  </div>
     
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={grnNo} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.purchaseOrderHeader_podate ? 
         new Date(poDetail.purchaseOrderHeader_podate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="scode" value={poNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Old GRN No :</label>
                <input type="text" name="sname" value={oldGrn} readOnly/>
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={poDetail.purchaseOrderHeader_suppliercode} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={poDetail.purchaseOrderHeader_supplierName} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="yourRefNo"   value={poDetail.purchaseOrderHeader_yourReferenceNumber} readOnly/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.purchaseOrderHeader_yourReferenceDate ? 
         new Date(poDetail.purchaseOrderHeader_yourReferenceDate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={subDetails.supplierMaster_addressline1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2} readOnly/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={subDetails.supplierMaster_city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Acc Qty</th>
                  </tr>
                </thead>
                <tbody>
  {data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.grnDetail_itemcode}</td>
        <td>{item.grnDetail_itemName}</td>
        <td>{item.grnDetail_uom}</td>
        <td>{item.grnDetail_poPendingQuantity}</td>
        <td>{item.grnDetail_price}</td>
        <td>{item.grnDetail_acceptedQuantity}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9">No items</td>
    </tr>
  )}
</tbody>
              </table>
            </div>        
          </form>    
        </div>  
      </div>
    </div>
  );
};

export default GrnRejectionViewSingleReport;
